<template>
  <div class="ApplicationSystemAlarmSearch">
    <Row :gutter="10">
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="applicationNameSearchKey"
          placeholder="按应用名称查询"
        />
      </Col>
      <Col span="4">
        <Button type="primary" @click="searchApplicationName">查询</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import TableApplicationSystemAlarm from "../application_system_alarm/TableApplicationSystemAlarm";
var tableApplicationSystemAlarm = TableApplicationSystemAlarm;
export default {
  name: "ApplicationSystemAlarmSearch",
  data() {
    return {
      applicationNameSearchKey: "",
      applicationNameSearchName: ""
    };
  },
  methods: {
    searchApplicationName: function() {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit(
        "applicationNameSearchName",
        this.applicationNameSearchKey
      );
      tableApplicationSystemAlarm.methods.showAll();
    }
  }
};
</script>
<style scoped>
.ApplicationSystemAlarmSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_system_alarm/ApplicationSystemAlarmSearch.vue